import React from 'react';
import { Select } from 'antd';

import { useLanguageContext } from '../../context/language-context';
import useTranslation from '../../Hooks/translation-hook';

import './LanguageSwitcher.css';

const LANGUAGE_OPTIONS = [
  { value: 'en', labelKey: 'language.english' },
  { value: 'ar', labelKey: 'language.arabic' },
];

/**
 * English / Arabic switcher for Storec-wide pages (always) and store pages (when multi-language is enabled).
 */
const LanguageSwitcher = ({ variant = 'header' }) => {
  const { isLanguageSwitchingEnabled, currentLanguage, setLanguage } = useLanguageContext();
  const { t } = useTranslation();

  if (!isLanguageSwitchingEnabled) {
    return null;
  }

  const options = LANGUAGE_OPTIONS.map(({ value, labelKey }) => ({
    value,
    label: t(labelKey),
  }));

  return (
    <div
      className="language-switcher-wrap"
      onClick={(event) => event.stopPropagation()}
    >
    <Select
      className={`language-switcher language-switcher--${variant}`}
      value={currentLanguage}
      onChange={setLanguage}
      options={options}
      popupMatchSelectWidth={false}
      aria-label={t('language.selectLanguage')}
      getPopupContainer={(triggerNode) => triggerNode.parentElement}
    />
    </div>
  );
};

export default LanguageSwitcher;
